import * as geom from "js/core/utilities/geom";
import { BaseElement } from "js/elements/base/BaseElement";
import { TextGroup } from "js/elements/base/TextGroup";

export class OrgChartRowLabel extends BaseElement {
    static get LABEL_WIDTH() {
        return 100;
    }

    _build() {
        this.text = this.addElement("text", () => TextGroup, {
            showBody: false
        });
    }

    _calcProps(props, options) {
        const { size, children, styles } = props;
        const textSize = this.text.calcSize(new geom.Size(OrgChartRowLabel.LABEL_WIDTH, size.height));
        this.text.bounds = new geom.Rect(0, size.height / 2 - textSize.height / 2, textSize);
        return { size };
    }
}
